import React from 'react';
import ThiefOfJoySplash from './components/ThiefOfJoySplash';
import './App.css';

function App() {
  return (
    <div className="App">
      <ThiefOfJoySplash />
    </div>
  );
}

export default App;
